import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59b02894"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存并派单 ")
const _hoisted_2 = { class: "flow-model-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_maintenance_team_select = _resolveComponent("maintenance-team-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'list')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal()))
        }, _toDisplayString(_ctx.operationType ? "转单" : "派单"), 1))
      : (_ctx.type === 'detail')
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.operationType ? "转单" : "派单"), 1)
            ]),
            _: 1
          }))
        : (_ctx.type === 'form')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal()))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      confirmLoading: _ctx.loading,
      centered: true,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
      onOk: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleOk()))
    }, {
      title: _withCtx(() => [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.operationType ? "转单" : "派单"), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "接单人",
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_maintenance_team_select, {
                  onChange: _ctx.userChange,
                  value: _ctx.formRef.acceptUserId,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formRef.acceptUserId) = $event)),
                  "max-count": 1
                }, null, 8, ["onChange", "value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.formRef.remark,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formRef.remark) = $event)),
                  "show-count": "",
                  placeholder: "请输入备注",
                  rows: 4,
                  maxlength: 200
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["confirmLoading", "visible"])
  ], 64))
}